module.exports = "https://static.wanderu.com/static/media/phone-with-qr.4c3a9c6c.png";